import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const investmentModule = {
  namespaced: true,
  state() {
    return {
      investmentdata: Object,
      selectedInvestment: Object,
      investmentEntitiesInfo: Array,
      investmentType: Array,
      projectionModel: Object,
      projectionAPIResponse: Object,
      compareInvestments: Array,
      investmentChartModel: Object,
    };
  },
  mutations,
  actions,
  getters,
};

export default investmentModule;
